<template>
  <v-list nav dense>
    <v-list-group active-class="white--text">
      <template v-slot:activator>
        <v-list-item-title>Employee Master File</v-list-item-title>
      </template>

      <v-list-item
        v-for="(item,key) in empMasterFileItems"
        :key="key"
        link
        :to="item.route"
        active-class="white--text"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-content class="pl-4" v-on="on">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>
          <span>{{item.title}}</span>
        </v-tooltip>
      </v-list-item>
    </v-list-group>

    <v-list-group active-class="white--text">
      <template v-slot:activator>
        <v-list-item-title>Employee Other Information</v-list-item-title>
      </template>

      <v-list-item
        v-for="(item,key) in empOtherItems"
        :key="key"
        link
        :to="item.route"
        active-class="white--text"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-content class="pl-4" v-on="on">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>
          <span>{{item.title}}</span>
        </v-tooltip>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>
<script>
export default {
  data: () => ({
    empMasterFileItems: [
      {
        title: "Personal Infomation",
        route: "/personal-info",
        isAuthorized: false,
        code: "ADD_USERS"
      },
      {
        title: "Employment Informaion",
        route: "/employment-info",
        isAuthorized: false,
        code: "AuditTrail"
      }
    ],
    empOtherItems: [
      {
        title: "Annual Physical Exams",
        route: "/annual-physical-exam",
        isAuthorized: false,
        code: "ADD_USERS"
      },
      {
        title: "Awards and Commendations",
        route: "/maint/awards",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Bank Accounts",
        route: "/back-accounts",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Benefit",
        route: "/maint/benefit",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Disciplinary Cases",
        route: "/disc-cases",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Disciplinary Remarks",
        route: "/disc-remarks",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Documents Submitted",
        route: "/maint/docs-submitted",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Duties and Responsibilities",
        route: "/maint/duties-responsibilities",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Education Background",
        route: "/educ-background",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Examinations Result",
        route: "/exams-result",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Family Information",
        route: "/family-info",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Forms Submitted to Government",
        route: "/forms-submitted",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Government Exams",
        route: "/maint/gov-exams",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Health Insurance",
        route: "/maint/health",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Health Record",
        route: "/health-record",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Insurance Claims",
        route: "/insurance-claims",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Languages and Dialects",
        route: "/maint/languages",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Licenses and Other Eligibilities",
        route: "/maint/licenses",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Medical Cases",
        route: "/maint/medical-cases",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Medical Reimbursements",
        route: "/maint/medical-reimbursements",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Memos Received",
        route: "/memos-received",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Narrative Report",
        route: "/narrative-report",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Previous Employment",
        route: "/preveios-emp",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Referral",
        route: "/referral",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "References",
        route: "/references",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Seminars and Trainings Recommendation",
        route: "/sem-tranings-recommendation",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Seminars and Tranings",
        route: "/sem-trainings",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Skills",
        route: "/maint/skills",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Specialization",
        route: "/maint/specialization",
        isAuthorized: false,
        code: "AuditTrail"
      },
      {
        title: "Status of BFY Overseas Placement",
        route: "/memos-received",
        isAuthorized: false,
        code: "AuditTrail"
      }
    ]
  })
};
</script>